module.exports = __webpack_public_path__ + "img/ico_detale-search.395d6baa.svg";